import CreateComponent from "../../components/create-user-component";

function Create() {
  return <CreateComponent />;
}

export default Create;
